import dynamicLocalization from "@/mixins/dynamic-localization";
import NewsletterTextBlock from "@/components/content-block/text";
import DateToFormat from "@/components/date-to-format";

export default {
  mixins: [dynamicLocalization],
  components: {
    DateToFormat,
    NewsletterTextBlock,
  },
  props: {
    accentClass: { type: String, required: false },
    title: { type: Object | String, required: true },
    location: { type: Object | String, required: true },
    date: { type: Date, required: false },
    remarks: { type: Array, required: false },
    events: { type: Array, required: false },
  },
};
